<div class="pa-1">
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div>
      <mat-form-field class="full-width">
        <mat-label>{{'hotelroom.content.room_number'| translate}}</mat-label>
        <input matInput type="text" formControlName="room_number"
          placeholder="{{ 'hotelroom.content.room_number'|translate }}">
        <mat-error *ngIf="form.get('room_number').invalid && form.get('room_number').touched"
          [flexFormControlError]="form.get('room_number')"
          [customMessages]="{
            'exists': 'hotelroom.message.room_number_exist'|translate
          }"></mat-error>
      </mat-form-field>
    </div>
    <div class="mt-1">
      <mat-slide-toggle formControlName="has_sipphone" color="primary">
        {{'hotelroom.content.also_create_sipphone'|translate}}
        <span [hidden]="!form.get('has_sipphone').value" class="mat-text-primary">
          {{ 'sipphone.content.enabled'|translate }}</span>
        <span [hidden]="form.get('has_sipphone').value" class="mat-text-muted">
          {{ 'sipphone.content.disabled'|translate }}</span>
      </mat-slide-toggle>
    </div>
  </form>
</div>
